import type { FC } from 'react';

import { Icon } from '@zen/DesignSystem';

interface SuggestionTextProps {
  id: string;
  onAccept: (id: string) => void;
  onReject: (id: string) => void;
  proposedValueText: string;
}

export const SuggestionText: FC<SuggestionTextProps> = ({ id, proposedValueText, onAccept, onReject }) => {
  return (
    <div className="rounded-4xl text-transparent flex items-center px-2 gap-2 justify-between w-auto h-8 bg-sunset-base bg-clip-text mt-2">
      <div className="flex items-center gap-2">
        <Icon icon="zicon-sparkles-empty" />
        <span className="font-extrabold block truncate max-w-40">{proposedValueText}</span> suggested
      </div>
      <div className="flex items-center gap-2">
        <Icon onClick={() => onAccept(id)} className="right-4 cursor-pointer" icon="zicon-tick" />
        <Icon onClick={() => onReject(id)} className="right-4 cursor-pointer" icon="zicon-close" />
      </div>
    </div>
  );
};
